export const ACTIVATE_SCANNER = 'cboard/ScannerProvider/ACTIVATE_SCANNER';
export const DEACTIVATE_SCANNER = 'cboard/ScannerProvider/DEACTIVATE_SCANNER';
export const TOGGLE_SCANNER = 'cboard/ScannerProvider/TOGGLE_SCANNER';
export const UPDATE_SCANNER_SETTINGS =
  'cboard/ScannerProvider/UPDATE_SCANNER_SETTINGS';
